import { render, staticRenderFns } from "./Fte.vue?vue&type=template&id=01878899&scoped=true&"
import script from "./Fte.vue?vue&type=script&lang=js&"
export * from "./Fte.vue?vue&type=script&lang=js&"
import style0 from "./Fte.vue?vue&type=style&index=0&id=01878899&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01878899",
  null
  
)

export default component.exports